import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../config";
import {
  IApiCustomerResponse,
  IApiLoopingResponse,
  IApiResponse,
  IShopOrder,
  IApiResponseInvoice,
  IApiResponseWorkOrder,
  ICategoryFilterPayload,
  ICategoryPayload,
  ICustomerProjectPayload,
  ICustomerTransactionPayload,
  IGetByCategoryArrayPayload,
  IGetByCategoryPayload,
  IInvoiceListPayload,
  ILoopingTableListPayload,
  IPriceHistoryPayload,
  IProductPayload,
  IVariantPayload,
  IModifierPayload,
  IModifierGroupPayload,
  IRemovedorkOrderByCustomerProjectPayload,
  ISearchIsActivePayload,
  ISearchPayload,
  ISelectCustomerPayload,
  IUpdateStatuInvoicePayload,
  IUpdateWorkOrderByCustomerProjectPayload,
  IUser,
  IWorkOrderByCustomerProjectPayload,
  IWorkOrderHistoryPayload,
  IEmail,
  IText,
  INote,
  INoteEmail,
  IActivityHistoryApiResponse,
  IActivityHistoryProjectApiResponse,
  IInvoiceHistoryPayload,
  IAssignDriverPayload,
  IApiShopProductResponse,
  ISearchRoutePayload,
} from "./Interface/api.interface";
/**
 * Holds all the API callbacks
 * @returns RTK Implementation for backend
 */

export const attoDeskApi = createApi({
  reducerPath: "attoDeskApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set(
        "Authorization",
        `Bearer ${localStorage.getItem("token") || ""}`
      );
      return headers;
    },
  }),
  tagTypes: [
    "User",
    "shopOrder",
    "shopInvoice",
    "category",
    "modifierCategory",
    "company",
    "department",
    "coursing",
    "tax",
    "product",
    "event",
    "printer",
    "productBrand",
    "productTag",
    "productCategory",
    "modifier",
    "modifierGroup",
    "modifierGrp",
    "productGetByCategory",
    "looping",
    "customer",
    "shop",
    "route",
    "shopProduct",
    "vendor",
    "inventory",
    "sold",
    "bill",
    "invoiceHistroy",
    "invoiceHistroyCustomer",
    "quote",
    "serializedItem",
    "workOrderHistroy",
    "billHistroy",
    "assignDriverHistory",
    "workOrderHistroyCustomer",
    "billHistoryCustomer",
    "invoice",
    "inquiry",
    "driver",
    "email",
    "note",
    "noteEmail",
    "emailTemplate",
    "noteTemplate",
    "activityHistory",
    "activityHistoryProject",
    "text",
    "unit",
    "device",
    "playlist",
    "playlistGroup",
    "media",
    "dashboard",
  ],
  endpoints: (builder) => ({
    getUser: builder.query<IApiResponse, void>({
      query: (request) => {
        return {
          url: "/user/userInfo",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["User"],
    }),
    login: builder.mutation<IApiResponse, IUser>({
      query: (request) => {
        return {
          url: "/login",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
    }),
    createCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/category",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["category", "productCategory"],
    }),
     createDuplicateCategory: builder.mutation<IApiResponse, Object>({
      query: (categoryId) => {
        return {
          url: `/category/${categoryId}/duplicate`,
          method: "POST",
        };
      },
      invalidatesTags: ["category", "productCategory"],
    }),
    reorderCategory: builder.mutation<IApiResponse, { orderedIds: number[] }>({
  query: (payload) => ({
    url: `/categories/reorder`,
    method: "POST",
    body: payload,
  }),
  invalidatesTags: ["category", "productCategory"], 
}),
   reorderProduct: builder.mutation<IApiResponse, {  categoryId: number, orderedIds: number[] }>({
  query: (payload) => ({
    url: `/products/reorder`,
    method: "POST",
    body: payload,
  }),
  invalidatesTags: ["product", "productCategory"], 
}),

      createModifierCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/modifierCategory",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["modifierCategory", "productCategory"],
    }),
    createCompany: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/company",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["company"],
    }),
    createDepartment: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/department",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["department"],
    }),
    createCoursing: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/coursing",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["coursing"],
    }),
    createTax: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/tax",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["tax", "product", "category"],
    }),
    createProductBrand: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/brand",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productBrand", "product"],
    }),
    createProductTag: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/tags",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productTag", "product"],
    }),
    createProductCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/category",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productCategory", "product"],
    }),
    createProduct: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/product",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["product"],
    }),

    // Units
    getUnits: builder.query<IApiResponse, void>({
      query: () => ({ url: "/units", method: "GET" }),
      providesTags: ["unit"],
    }),
    createUnit: builder.mutation<IApiResponse, { name: string; abbreviation?: string }>({
      query: (request) => ({
        url: "/units",
        method: "POST",
        body: JSON.stringify(request),
      }),
      invalidatesTags: ["unit"],
    }),

    // Tax Groups
    getTaxGroups: builder.query<IApiResponse, void>({
      query: () => ({ url: "/tax-groups", method: "GET" }),
    }),

     createEvent: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/event",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["event"],
    }),
       createVariant: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/variant",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["product"],
    }),
      createModifier: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/modifier",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["modifier"],
    }),
     createModifierGroup: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/modifierGroup",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["modifierGroup"],
    }),
       createModifierGrp: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/modifierGrp",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["modifierGrp"],
    }),
    createPrinter: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/printer",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["printer", "product"],
    }),
    getCategory: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/category/getAll",
          method: "POST",
        };
      },
      providesTags: ["product", "category"],
      keepUnusedDataFor: 0,
    }),
    getModifierCategory: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/modifierCategory/getAll",
          method: "POST",
        };
      },
      providesTags: ["product", "modifierCategory"],
      keepUnusedDataFor: 0,
    }),
    getSalesCategory: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/view-sales-categories",
          method: "POST",
        };
      },
      providesTags: ["product", "category"],
      keepUnusedDataFor: 0,
    }),
    getAllMainCategory: builder.query<IApiResponse, ICategoryPayload>({
      query: (request) => {
        return {
          url: "/main-category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product", "category"],
      keepUnusedDataFor: 0,
    }),
      getAllMainModifierCategory: builder.query<IApiResponse, ICategoryPayload>({
      query: (request) => {
        return {
          url: "/mainModifierCategory/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product", "modifierCategory"],
      keepUnusedDataFor: 0,
    }),
    deleteCoursing: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/coursing/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["coursing"],
    }),
    deleteDepartment: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/department/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["department"],
    }),
    deletePrinter: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/printer/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["printer"],
    }),
    deleteEmailTemplate: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email-template/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["emailTemplate"],
    }),
    deleteNoteTemplate: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/note-template/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["noteTemplate"],
    }),
    deleteProductBrand: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/brand/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["productBrand"],
    }),
    deleteProductTag: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/tags/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["productTag"],
    }),
    deleteTax: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/tax/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["tax"],
    }),
    deleteProductCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/category/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["productCategory"],
    }),
    deleteCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/category/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["category", "productCategory"],
    }),
       deleteModifierCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/modifierCategory/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["modifierCategory", "productCategory"],
    }),
    getProduct: builder.query<IApiResponse, IProductPayload>({
      query: (request) => {
        return {
          url: "/product/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "product", "quote"],
      keepUnusedDataFor: 0,
    }),
       getEvent: builder.query<IApiResponse, IProductPayload>({
      query: (request) => {
        return {
          url: "/event/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "event", "quote"],
      keepUnusedDataFor: 0,
    }),
       getVariant: builder.query<IApiResponse, IVariantPayload>({
      query: (request) => {
        return {
          url: "/variant/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "product", "quote"],
      keepUnusedDataFor: 0,
    }),
    createGetAllProduct: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/getAll",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productTag", "product"],
    }),
    deleteProduct: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["product"],
    }),
     deleteEvent: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/event/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["event"],
    }),
       deleteVariant: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/variant/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["product"],
    }),
    getLastProductId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/product/last-id",
          method: "GET",
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    getNextProductBarcode: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/product/next-barcode",
          method: "GET",
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
     getModifier: builder.query<IApiResponse, IModifierPayload>({
      query: (request) => {
        return {
          url: "/modifier/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "modifier", "quote"],
      keepUnusedDataFor: 0,
    }),
    createGetAllModifier: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/modifier/getAll",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productTag", "modifier"],
    }),
    deleteModifier: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/modifier/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["modifier"],
    }),
    getModifierGroup: builder.query<IApiResponse,IModifierGroupPayload >({
      query: (request) => {
        return {
          url: "/modifierGroup/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "modifierGroup", "quote"],
      keepUnusedDataFor: 0,
    }),
      getModifierGrp: builder.query<IApiResponse,IModifierGroupPayload >({
      query: (request) => {
        return {
          url: "/modifierGrp/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "modifierGrp", "quote"],
      keepUnusedDataFor: 0,
    }),
    createGetAllModifierGroup: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/modifierGroup/getAll",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productTag", "modifierGroup"],
    }),
    deleteModifierGroup: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/modifierGroup/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["modifierGroup"],
    }),
      deleteModifierGrp: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/modifierGrp/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["modifierGrp"],
    }),
   
    getDepartment: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/department/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["department", "category"],
      keepUnusedDataFor: 0,
    }),
    getTax: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/tax/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["tax", "category", "product"],
      keepUnusedDataFor: 0,
    }),
    getCoursing: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/coursing/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["coursing", "category"],
      keepUnusedDataFor: 0,
    }),
    getPrinter: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/printer/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["printer", "product"],
      keepUnusedDataFor: 0,
    }),
    getEmailTemplate: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/email-template/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["emailTemplate"],
      keepUnusedDataFor: 0,
    }),
    getNoteTemplate: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/note-template/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["noteTemplate"],
      keepUnusedDataFor: 0,
    }),
    getProductTag: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/product/tags/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "product"],
      keepUnusedDataFor: 0,
    }),
    getProductBrand: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/product/brand/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productBrand", "product"],
      keepUnusedDataFor: 0,
    }),
    getProductCategory: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/product/category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productCategory", "product"],
      keepUnusedDataFor: 0,
    }),
    // getSubCategoryByCategoryId: builder.query<IApiResponse, ISearchIsActivePayload>({
    //   query: (request) => {
    //     return {
    //       url: '/product/category/getAll',
    //       method: "POST",
    //       body: request,
    //     };
    //   },
    //   providesTags:['productCategory','product'],
    //   keepUnusedDataFor: 0,
    // }),
    getSubCategoryByCategoryId: builder.query<
      IApiResponse,
      IGetByCategoryPayload
    >({
      query: (request) => {
        return {
          url: "/product/get-by-categories",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productGetByCategory", "product"],
      keepUnusedDataFor: 0,
    }),
    getSubCategoryByArray: builder.query<
      IApiResponse,
      IGetByCategoryArrayPayload
    >({
      query: (request) => {
        return {
          url: "/category/category-fiter/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productGetByCategory", "product", "productCategory"],
      keepUnusedDataFor: 0,
    }),
    getProductSubCategory: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/category/sub-category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productCategory", "product"],
      keepUnusedDataFor: 0,
    }),
    getAllCategoryName: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/all-category/getAll",
          method: "POST",
        };
      },
      providesTags: ["productCategory"],
      keepUnusedDataFor: 0,
    }),
     getAllModifierCategoryName: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/all-modifier-category/getAll",
          method: "POST",
        };
      },
      providesTags: ["productCategory"],
      keepUnusedDataFor: 0,
    }),
    getCtegoryFilter: builder.query<IApiResponse, ICategoryFilterPayload>({
      query: (request) => {
        return {
          url: "/category/filter",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    getLoopingTable: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/looping/list-tables",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["category", "product", "looping"],
      keepUnusedDataFor: 0,
    }),
    createLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/create-table",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["looping", "product"],
    }),
    getAllLoopingTable: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/looping/list-tables",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["looping", "product"],
      keepUnusedDataFor: 0,
    }),
    deleteLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/delete-table",
          method: "DELETE",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["looping", "product"],
    }),
    updateLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/update-table",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["looping", "product"],
    }),
    insertOrUpdateDataLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/table/insert-update-data",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["product", "looping"],
    }),
    getCustomer: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/customer/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer"],
      keepUnusedDataFor: 0,
    }),
    getShop: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/shop/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["shop"],
      keepUnusedDataFor: 0,
    }),
    getRoute: builder.query<IApiResponse, ISearchRoutePayload>({
      query: (request) => {
        return {
          url: "/route/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["route"],
      keepUnusedDataFor: 0,
    }),
     getShopProduct: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/shop-product/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["shopProduct"],
      keepUnusedDataFor: 0,
    }),
     getVendor: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/vendor/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["vendor"],
      keepUnusedDataFor: 0,
    }),
    getProductSuppliers: builder.query<IApiResponse, string>({
      query: (productId) => ({
        url: `/product/${productId}/suppliers`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    getSupplierProducts: builder.query<IApiResponse, string>({
      query: (vendorId) => ({
        url: `/vendor/${vendorId}/products`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    getProductBarcodes: builder.query<IApiResponse, string>({
      query: (productId) => ({ url: `/product/${productId}/barcodes`, method: "GET" }),
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    addProductBarcode: builder.mutation<IApiResponse, { productId: string; barcode: string; type: string; is_primary?: boolean }>({
      query: ({ productId, ...body }) => ({ url: `/product/${productId}/barcodes`, method: "POST", body: JSON.stringify(body) }),
      invalidatesTags: ["product"],
    }),
    setBarcodePrimary: builder.mutation<IApiResponse, string>({
      query: (id) => ({ url: `/product-barcodes/${id}/primary`, method: "PUT" }),
      invalidatesTags: ["product"],
    }),
    deleteBarcode: builder.mutation<IApiResponse, string>({
      query: (id) => ({ url: `/product-barcodes/${id}`, method: "DELETE" }),
      invalidatesTags: ["product"],
    }),
    scanBarcode: builder.query<IApiResponse, string>({
      query: (code) => ({ url: `/barcode/scan/${code}`, method: "GET" }),
    }),
    getProductHistory: builder.query<IApiResponse, string>({
      query: (productId) => ({
        url: `/product/${productId}/history`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    linkProductToSupplier: builder.mutation<IApiResponse, { vendorId: string; product_id: number; supplier_price: number; supplier_unit: string; unit_conversion?: string; is_default?: boolean }>({
      query: ({ vendorId, ...body }) => ({
        url: `/vendor/${vendorId}/products`,
        method: "POST",
        body: JSON.stringify(body),
      }),
    }),
      getInventory: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/inventory/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["inventory"],
      keepUnusedDataFor: 0,
    }),
    getSold: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/sold/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["sold"],
      keepUnusedDataFor: 0,
    }),
   
    getActivityHistory: builder.query<IActivityHistoryApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/customer/activityHistory/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["activityHistory"],
      keepUnusedDataFor: 0,
    }),

      getActivityHistoryVendor: builder.query<IActivityHistoryApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/vendor/activityHistory/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["activityHistory"],
      keepUnusedDataFor: 0,
    }),

    getProjectActivityHistory: builder.query<IActivityHistoryProjectApiResponse, ICustomerProjectPayload>({
      query: (request) => {
        return {
          url: "/customer/project/activityHistory/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["activityHistoryProject"],
      keepUnusedDataFor: 0,
    }),
     getInquiryActivityHistory: builder.query<IActivityHistoryProjectApiResponse, ICustomerProjectPayload>({
      query: (request) => {
        return {
          url: "/customer/inquiry/activityHistory/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["activityHistoryProject"],
      keepUnusedDataFor: 0,
    }),
    deleteCustomer: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/customer/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
      deleteShop: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/shop/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["shop"],
    }),
     deleteRoute: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/route/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["route"],
    }),
     deleteVendor: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/vendor/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["vendor"],
    }),
     
    createCustomer: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/customer",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
     createShop: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/shop",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["shop"],
    }),
     createRoute: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/route",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["route"],
    }),
      createShopProduct: builder.mutation<IApiShopProductResponse, { shopId: number; products: number[] }>({
  query: ({ shopId, products }) => ({
    url: `/shop-product/${shopId}`,
    method: "PUT",
    body: JSON.stringify({ products }),
  }),
  invalidatesTags: ["shopProduct"],
}),
    updateShopProductPrice: builder.mutation<IApiResponse, { shopId: number; productId: number; custom_price: number | null }>({
  query: ({ shopId, productId, custom_price }) => ({
    url: `/shop-product/${shopId}/${productId}/price`,
    method: "PUT",
    body: JSON.stringify({ custom_price }),
  }),
  invalidatesTags: ["shopProduct"],
}),
     createVendor: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/vendor",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["vendor"],
    }),
   
    getCustomerTransaction: builder.query<
      IApiResponse,
      ICustomerTransactionPayload
    >({
      query: (request) => {
        return {
          url: "/customer/transaction/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer"],
      keepUnusedDataFor: 0,
    }),
    deleteCustomerTransaction: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/customer/transaction/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
    createCustomerTransaction: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/customer/transaction",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
    getCompany: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/company/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["company"],
      keepUnusedDataFor: 0,
    }),
    deleteCompany: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/company/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["company"],
    }),
    getAllSearchCompany: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/company/search/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["company"],
      keepUnusedDataFor: 0,
    }),
    createWorkOrder: builder.mutation<IApiResponseWorkOrder, Object>({
      query: (request) => {
        return {
          url: "/work-order",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["quote"],
    }),
     createBill: builder.mutation<IApiResponseWorkOrder, Object>({
      query: (request) => {
        return {
          url: "/bill",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["bill"],
    }),
    editInvoice: builder.mutation<IApiResponseWorkOrder, Object>({
      query: (request) => {
        return {
          url: "/work-order/edit-invoice",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["quote"],
    }),
    getLastWorkOrderId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/work-order/next-id",
          method: "GET",
        };
      },
      providesTags: ["quote"],
      keepUnusedDataFor: 0,
    }),
     getLastBillId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/bill/next-id",
          method: "GET",
        };
      },
      providesTags: ["quote"],
      keepUnusedDataFor: 0,
    }),
    getWorkOrder: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/work-order/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["quote", "workOrderHistroy"],
      keepUnusedDataFor: 0,
    }),
       getBill: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/bill/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["bill"],
      keepUnusedDataFor: 0,
    }),
     getSerializedItem: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/serializedItem/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["serializedItem"],
      keepUnusedDataFor: 0,
    }),
    updateInvoiceStatus: builder.query<
      IApiResponse,
      IUpdateStatuInvoicePayload
    >({
      query: (request) => {
        return {
          url: "/work-order/update-invoice",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["workOrderHistroy"],
      keepUnusedDataFor: 0,
    }),
    getAllAssignDriverHistory: builder.query<
    IApiResponse,
    IAssignDriverPayload
  >({
    query: (request) => {
      return {
        url: "/assign-driver-history",
        method: "POST",
        body: request,
      };
    },
    providesTags: ["assignDriverHistory"],
    keepUnusedDataFor: 0,
  }),
    getAllInvoice: builder.query<IApiResponse, IInvoiceListPayload>({
      query: (request) => {
        return {
          url: "/invoice/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["invoice"],
      keepUnusedDataFor: 0,
    }),
       getAllInquiry: builder.query<IApiResponse, ICustomerProjectPayload>({
      query: (request) => {
        return {
          url: "/customer/inquiry/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["inquiry"],
      keepUnusedDataFor: 0,
    }),
     getAllBill: builder.query<IApiResponse, IInvoiceListPayload>({
      query: (request) => {
        return {
          url: "/bill/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["bill"],
      keepUnusedDataFor: 0,
    }),
    getAllInvoiceHistory: builder.query<
    IApiResponse,
    IInvoiceHistoryPayload
  >({
    query: (request) => {
      return {
        url: "/invoice-history",
        method: "POST",
        body: request,
      };
    },
    providesTags: ["invoiceHistroy"],
    keepUnusedDataFor: 0,
  }),

    getAllWorkOrderHistory: builder.query<
      IApiResponse,
      IWorkOrderHistoryPayload
    >({
      query: (request) => {
        return {
          url: "/work-order-history",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["workOrderHistroy"],
      keepUnusedDataFor: 0,
    }),
    getAllWorkOrderHistoryCustomer: builder.query<
    IApiResponse,
    IWorkOrderHistoryPayload
  >({
    query: (request) => {
      return {
        url: "/work-order-history-by-customer",
        method: "POST",
        body: request,
      };
    },
    providesTags: ["workOrderHistroyCustomer"],
    keepUnusedDataFor: 0,
  }),
   getAllBillHistory: builder.query<
      IApiResponse,
      IWorkOrderHistoryPayload
    >({
      query: (request) => {
        return {
          url: "/bill-history",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["billHistroy"],
      keepUnusedDataFor: 0,
    }),
    getAllBillHistoryCustomer: builder.query<
    IApiResponse,
    IWorkOrderHistoryPayload
  >({
    query: (request) => {
      return {
        url: "/bill-history-by-customer",
        method: "POST",
        body: request,
      };
    },
    providesTags: ["billHistoryCustomer"],
    keepUnusedDataFor: 0,
  }),
    createDriver: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/driver",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["driver"],
    }),
    getDriver: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/driver/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["driver"],
      keepUnusedDataFor: 0,
    }),
    deleteDriver: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/driver/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["driver"],
    }),
    getPriceHistory: builder.query<IApiResponse, IPriceHistoryPayload>({
      query: (request) => {
        return {
          url: "/work-order/price",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["quote"],
      keepUnusedDataFor: 0,
    }),
      getBillPriceHistory: builder.query<IApiResponse, IPriceHistoryPayload>({
      query: (request) => {
        return {
          url: "/bill/price",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["quote"],
      keepUnusedDataFor: 0,
    }),
    getCustomerProject: builder.query<IApiResponse,  ICustomerProjectPayload >({
      query: (request) => {
        return {
          url: "/customer/project/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer"],
      keepUnusedDataFor: 0,
    }),
    deleteCustomerProject: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/customer/project/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
     deleteCustomerInquiry: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/customer/inquiry/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
    createCustomerProject: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/customer/project",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
      createCustomerInquiry: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/customer/inquiry",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["inquiry"],
    }),
    getWorkOrderByCustomerProject: builder.query<
      IApiResponse,
      IWorkOrderByCustomerProjectPayload
    >({
      query: (request) => {
        return {
          url: "/work-order/project/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer"],
      keepUnusedDataFor: 0,
    }),
    getSelectorWorkOrderByCustomerProject: builder.query<IApiResponse, ISelectCustomerPayload>({
      query: (request) => {
        return {
          url: "/work-order/project/selector/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer"],
      keepUnusedDataFor: 0,
    }),

    updateWorkOrderByCustomerProject: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/work-order/assign-project",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
    removedCustomerProjectM: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/work-order/project/remove",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
    createWorkOrderWithProject: builder.mutation<IApiResponseWorkOrder, Object>({
      query: (request) => {
        return {
          url: "/work-order/project-id",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["quote"],
    }),
    createEmail: builder.mutation<IEmail, Object>({
      query: (request) => {
        return {
          url: "/send-email",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email"],
    }),
     createCall: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/save-call",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email"],
    }),

    createEmailInvoice: builder.mutation<IApiResponseInvoice, FormData>({
      query: (formData) => {
        return {
          url: "/send-invoice-email",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["email"],
    }),

    createText: builder.mutation<IText, Object>({
      query: (request) => {
        return {
          url: "/send-text",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["text"],
    }),
    
    
  
  createNote: builder.mutation<INote, Object>({
    query: (request) => {
      return {
        url: "/save-note",
        method: "POST",
        body: JSON.stringify(request),
      };
    },
    invalidatesTags: ["note"],
  }),

  createNoteEmail: builder.mutation<INoteEmail, Object>({
    query: (request) => {
      return {
        url: "/send-note-email",
        method: "POST",
        body: JSON.stringify(request),
      };
    },
    invalidatesTags: ["noteEmail"],
  }),

  createEmailTemplate: builder.mutation<IApiResponse, Object>({
    query: (request) => {
      return {
        url: "/email-template",
        method: "POST",
        body: JSON.stringify(request),
      };
    },
    invalidatesTags: ["emailTemplate"],
  }),
  createNoteTemplate: builder.mutation<IApiResponse, Object>({
    query: (request) => {
      return {
        url: "/note-template",
        method: "POST",
        body: JSON.stringify(request),
      };
    },
    invalidatesTags: ["noteTemplate"],
  }),
  getShopOrders: builder.query<{ success: boolean; data: IShopOrder[] }, number>({
    query: (shopId) => ({
      url: `/shop-orders/${shopId}`,
      method: "GET",
    }),
    providesTags: ["shopOrder"],
    keepUnusedDataFor: 0,
  }),
  createShopOrder: builder.mutation<IApiResponse, { shopId: number; items: any[]; total: number; notes?: string }>({
    query: ({ shopId, ...body }) => ({
      url: `/shop-orders/${shopId}`,
      method: "POST",
      body: JSON.stringify(body),
    }),
    invalidatesTags: ["shopOrder"],
  }),
  updateShopOrderStatus: builder.mutation<IApiResponse, { orderId: number; status: string }>({
    query: ({ orderId, status }) => ({
      url: `/shop-orders/${orderId}/status`,
      method: "PUT",
      body: JSON.stringify({ status }),
    }),
    invalidatesTags: ["shopOrder"],
  }),

  // Shop Invoices
  getShopInvoices: builder.query<{ success: boolean; data: any[] }, { searchText?: string; shop_id?: number; payment_status?: string }>({
    query: (body) => ({ url: `/shop-invoices/getAll`, method: "POST", body: JSON.stringify(body) }),
    providesTags: ["shopInvoice"],
    keepUnusedDataFor: 0,
  }),
  createShopInvoice: builder.mutation<any, { shop_order_id: number }>({
    query: (body) => ({ url: `/shop-invoices`, method: "POST", body: JSON.stringify(body) }),
    invalidatesTags: ["shopInvoice", "shopOrder"],
  }),
  getShopInvoice: builder.query<{ success: boolean; data: any }, number>({
    query: (id) => ({ url: `/shop-invoices/${id}`, method: "GET" }),
    providesTags: ["shopInvoice"],
  }),
  addShopInvoicePayment: builder.mutation<IApiResponse, { invoiceId: number; amount: number; payment_method: string; payment_date: string; notes?: string }>({
    query: ({ invoiceId, ...body }) => ({ url: `/shop-invoices/${invoiceId}/payment`, method: "POST", body: JSON.stringify(body) }),
    invalidatesTags: ["shopInvoice"],
  }),
  deleteShopInvoicePayment: builder.mutation<IApiResponse, number>({
    query: (paymentId) => ({ url: `/shop-invoice-payments/${paymentId}`, method: "DELETE" }),
    invalidatesTags: ["shopInvoice"],
  }),
  // ── Warehouse endpoints ──
  getWarehouseAlerts: builder.query<IApiResponse, void>({
    query: () => ({ url: "/warehouse/alerts", method: "GET" }),
    keepUnusedDataFor: 0,
  }),
  receiveStock: builder.mutation<IApiResponse, any>({
    query: (body) => ({ url: "/warehouse/receive-stock", method: "POST", body }),
    invalidatesTags: ["inventory"],
  }),
  getWarehouseForecastData: builder.mutation<IApiResponse, any>({
    query: (body) => ({ url: "/warehouse/forecast-data", method: "POST", body }),
  }),

  // ─── Digital Signage: Devices ──────────────────────────────────────
  getDevices: builder.query<IApiResponse, { searchText?: string } | void>({
    query: (body) => ({ url: "/devices/getAll", method: "POST", body: body || {} }),
    providesTags: ["device"],
  }),
  getDevice: builder.query<IApiResponse, number>({
    query: (id) => ({ url: `/devices/${id}`, method: "GET" }),
    providesTags: ["device"],
  }),
  createDevice: builder.mutation<IApiResponse, Object>({
    query: (body) => ({ url: "/devices", method: "POST", body }),
    invalidatesTags: ["device"],
  }),
  updateDevice: builder.mutation<IApiResponse, { id: number; body: Object }>({
    query: ({ id, body }) => ({ url: `/devices/${id}`, method: "PUT", body }),
    invalidatesTags: ["device"],
  }),
  deleteDevice: builder.mutation<IApiResponse, number>({
    query: (id) => ({ url: `/devices/${id}`, method: "DELETE" }),
    invalidatesTags: ["device"],
  }),
  assignDevicePlaylist: builder.mutation<
    IApiResponse,
    { id: number; playlist_id: number | null }
  >({
    query: ({ id, playlist_id }) => ({
      url: `/devices/${id}/assign-playlist`,
      method: "POST",
      body: { playlist_id },
    }),
    invalidatesTags: ["device"],
  }),

  // ─── Digital Signage: Playlists ────────────────────────────────────
  getPlaylists: builder.query<IApiResponse, { searchText?: string } | void>({
    query: (body) => ({ url: "/playlists/getAll", method: "POST", body: body || {} }),
    providesTags: ["playlist"],
  }),
  getPlaylist: builder.query<IApiResponse, number>({
    query: (id) => ({ url: `/playlists/${id}`, method: "GET" }),
    providesTags: ["playlist"],
  }),
  createPlaylist: builder.mutation<IApiResponse, Object>({
    query: (body) => ({ url: "/playlists", method: "POST", body }),
    invalidatesTags: ["playlist"],
  }),
  updatePlaylist: builder.mutation<IApiResponse, { id: number; body: Object }>({
    query: ({ id, body }) => ({ url: `/playlists/${id}`, method: "PUT", body }),
    invalidatesTags: ["playlist"],
  }),
  deletePlaylist: builder.mutation<IApiResponse, number>({
    query: (id) => ({ url: `/playlists/${id}`, method: "DELETE" }),
    invalidatesTags: ["playlist", "device"],
  }),
  addPlaylistItem: builder.mutation<
    IApiResponse,
    { id: number; media_id: number; duration?: number | null }
  >({
    query: ({ id, ...body }) => ({
      url: `/playlists/${id}/items`,
      method: "POST",
      body,
    }),
    invalidatesTags: ["playlist"],
  }),
  removePlaylistItem: builder.mutation<
    IApiResponse,
    { playlistId: number; itemId: number }
  >({
    query: ({ playlistId, itemId }) => ({
      url: `/playlists/${playlistId}/items/${itemId}`,
      method: "DELETE",
    }),
    invalidatesTags: ["playlist"],
  }),
  reorderPlaylistItems: builder.mutation<
    IApiResponse,
    { id: number; item_ids: number[] }
  >({
    query: ({ id, item_ids }) => ({
      url: `/playlists/${id}/items/reorder`,
      method: "POST",
      body: { item_ids },
    }),
    invalidatesTags: ["playlist"],
  }),

  // ─── Digital Signage: Media ────────────────────────────────────────
  getMedia: builder.query<
    IApiResponse,
    { searchText?: string; type?: "image" | "video" } | void
  >({
    query: (body) => ({ url: "/media/getAll", method: "POST", body: body || {} }),
    providesTags: ["media"],
  }),
  deleteMedia: builder.mutation<IApiResponse, number>({
    query: (id) => ({ url: `/media/${id}`, method: "DELETE" }),
    invalidatesTags: ["media", "playlist"],
  }),

  // ─── Digital Signage: Playlist Groups ──────────────────────────────
  getPlaylistGroups: builder.query<IApiResponse, { searchText?: string; company_id?: number } | void>({
    query: (body) => ({ url: "/playlist-groups/getAll", method: "POST", body: body || {} }),
    providesTags: ["playlistGroup"],
  }),
  getPlaylistGroup: builder.query<IApiResponse, number>({
    query: (id) => ({ url: `/playlist-groups/${id}`, method: "GET" }),
    providesTags: ["playlistGroup"],
  }),
  createPlaylistGroup: builder.mutation<IApiResponse, Object>({
    query: (body) => ({ url: "/playlist-groups", method: "POST", body }),
    invalidatesTags: ["playlistGroup", "dashboard"],
  }),
  updatePlaylistGroup: builder.mutation<IApiResponse, { id: number; body: Object }>({
    query: ({ id, body }) => ({ url: `/playlist-groups/${id}`, method: "PUT", body }),
    invalidatesTags: ["playlistGroup", "dashboard"],
  }),
  deletePlaylistGroup: builder.mutation<IApiResponse, number>({
    query: (id) => ({ url: `/playlist-groups/${id}`, method: "DELETE" }),
    invalidatesTags: ["playlistGroup", "device", "dashboard"],
  }),
  addPlaylistToGroup: builder.mutation<
    IApiResponse,
    { id: number; playlist_id: number; duration_minutes?: number | null; is_active?: boolean }
  >({
    query: ({ id, ...body }) => ({
      url: `/playlist-groups/${id}/items`,
      method: "POST",
      body,
    }),
    invalidatesTags: ["playlistGroup"],
  }),
  updatePlaylistGroupItem: builder.mutation<
    IApiResponse,
    { groupId: number; itemId: number; body: Object }
  >({
    query: ({ groupId, itemId, body }) => ({
      url: `/playlist-groups/${groupId}/items/${itemId}`,
      method: "PUT",
      body,
    }),
    invalidatesTags: ["playlistGroup"],
  }),
  removePlaylistFromGroup: builder.mutation<
    IApiResponse,
    { groupId: number; itemId: number }
  >({
    query: ({ groupId, itemId }) => ({
      url: `/playlist-groups/${groupId}/items/${itemId}`,
      method: "DELETE",
    }),
    invalidatesTags: ["playlistGroup"],
  }),
  reorderPlaylistGroupItems: builder.mutation<
    IApiResponse,
    { id: number; item_ids: number[] }
  >({
    query: ({ id, item_ids }) => ({
      url: `/playlist-groups/${id}/items/reorder`,
      method: "POST",
      body: { item_ids },
    }),
    invalidatesTags: ["playlistGroup"],
  }),
  assignDevicePlaylistGroup: builder.mutation<
    IApiResponse,
    { id: number; playlist_group_id: number | null }
  >({
    query: ({ id, playlist_group_id }) => ({
      url: `/devices/${id}/assign-playlist-group`,
      method: "POST",
      body: { playlist_group_id },
    }),
    invalidatesTags: ["device", "playlistGroup"],
  }),

  // ─── Digital Signage: Dashboard ────────────────────────────────────
  getDashboardSummary: builder.query<IApiResponse, void>({
    query: () => ({ url: "/dashboard/summary", method: "GET" }),
    providesTags: ["dashboard"],
    // Aggregates from device/playlist/media tables — recompute when any change.
    keepUnusedDataFor: 30,
  }),
}),


});

export const {
  useGetUserQuery,
  useLoginMutation,
  useCreateCategoryMutation,
  useCreateDuplicateCategoryMutation,
  useCreateModifierCategoryMutation,
  useCreateCompanyMutation,
  useCreateDepartmentMutation,
  useCreateCoursingMutation,
  useCreateTaxMutation,
  useGetDepartmentQuery,
  useCreateProductBrandMutation,
  useCreateProductTagMutation,
  useCreateProductCategoryMutation,
  useCreateProductMutation,
  useCreateEventMutation,
  useCreateVariantMutation,
  useCreateModifierMutation,
  useCreateModifierGroupMutation,
  useCreateModifierGrpMutation,
  useCreatePrinterMutation,
  useGetCategoryQuery,
  useGetModifierCategoryQuery,
  useGetSalesCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetAllMainModifierCategoryQuery,
  useDeleteCoursingMutation,
  useDeleteDepartmentMutation,
  useDeletePrinterMutation,
  useDeleteEmailTemplateMutation,
  useCreateEmailInvoiceMutation,
  useDeleteNoteTemplateMutation,
  useDeleteProductBrandMutation,
  useDeleteProductTagMutation,
  useDeleteTaxMutation,
  useDeleteProductCategoryMutation,
  useDeleteCategoryMutation,
  useReorderCategoryMutation,
  useReorderProductMutation,
  useDeleteModifierCategoryMutation,
  useGetProductQuery,
  useGetEventQuery,
  useGetVariantQuery,
  useGetModifierQuery,
  useGetModifierGroupQuery,
  useGetModifierGrpQuery,
  useCreateGetAllProductMutation,
  useDeleteProductMutation,
  useDeleteEventMutation,
  useDeleteVariantMutation,
  useGetLastProductIdQuery,
  useGetNextProductBarcodeQuery,
  useCreateGetAllModifierMutation,
  useDeleteModifierMutation,
  useDeleteModifierGroupMutation,
  useDeleteModifierGrpMutation,
  useGetTaxQuery,
  useGetCoursingQuery,
  useGetPrinterQuery,
  useGetProductTagQuery,
  useGetProductBrandQuery,
  useGetProductCategoryQuery,
  useGetSubCategoryByCategoryIdQuery,
  useGetSubCategoryByArrayQuery,
  useGetProductSubCategoryQuery,
  useGetAllCategoryNameQuery,
  useGetAllModifierCategoryNameQuery,
  useGetCtegoryFilterQuery,
  useGetLoopingTableQuery,
  useCreateLoopingTableMutation,
  useGetAllLoopingTableQuery,
  useDeleteLoopingTableMutation,
  useUpdateLoopingTableMutation,
  useInsertOrUpdateDataLoopingTableMutation,
  useGetCustomerQuery,
  useGetShopQuery,
  useGetRouteQuery,
  useGetShopProductQuery,
  useGetVendorQuery,
  useGetSerializedItemQuery,
  useGetInventoryQuery,
  useGetSoldQuery,
  useGetBillQuery,
  useDeleteCustomerMutation,
  useDeleteVendorMutation,
  useDeleteShopMutation,
  useDeleteRouteMutation,
  useCreateCustomerMutation,
  useCreateShopMutation,
  useCreateRouteMutation,
  useCreateShopProductMutation,
  useUpdateShopProductPriceMutation,
  useCreateVendorMutation,
  useGetCustomerTransactionQuery,
  useDeleteCustomerTransactionMutation,
  useCreateCustomerTransactionMutation,
  useDeleteCompanyMutation,
  useGetCompanyQuery,
  useGetAllSearchCompanyQuery,
  useCreateWorkOrderMutation,
  useCreateBillMutation,
  useEditInvoiceMutation,
  useGetLastWorkOrderIdQuery,
  useGetLastBillIdQuery,
  useGetWorkOrderQuery,
  useUpdateInvoiceStatusQuery,
  useGetAllInvoiceQuery,
  useGetAllInquiryQuery,
  useGetAllBillQuery,
  useGetAllWorkOrderHistoryQuery,
  useGetAllBillHistoryQuery,
  useGetAllInvoiceHistoryQuery,
  useGetAllAssignDriverHistoryQuery,
  useGetAllWorkOrderHistoryCustomerQuery,
  useGetAllBillHistoryCustomerQuery,
  useCreateDriverMutation,
  useGetDriverQuery,
  useDeleteDriverMutation,
  useGetPriceHistoryQuery,
  useGetBillPriceHistoryQuery,
  useCreateCustomerProjectMutation,
  useCreateCustomerInquiryMutation,
  useDeleteCustomerProjectMutation,
  useDeleteCustomerInquiryMutation,
  useGetCustomerProjectQuery,
  useGetWorkOrderByCustomerProjectQuery,
  useUpdateWorkOrderByCustomerProjectMutation,
  useGetSelectorWorkOrderByCustomerProjectQuery,
  useRemovedCustomerProjectMMutation,
  useCreateWorkOrderWithProjectMutation,
  useCreateEmailMutation,
  useCreateCallMutation,
  useCreateTextMutation,
  useCreateNoteMutation,
  useCreateNoteEmailMutation,
  useCreateEmailTemplateMutation,
  useCreateNoteTemplateMutation,
  useGetEmailTemplateQuery,
  useGetNoteTemplateQuery,
  useGetActivityHistoryQuery,
  useGetActivityHistoryVendorQuery,
  useGetProjectActivityHistoryQuery,
  useGetInquiryActivityHistoryQuery,
  useGetShopOrdersQuery,
  useCreateShopOrderMutation,
  useUpdateShopOrderStatusMutation,
  useGetShopInvoicesQuery,
  useCreateShopInvoiceMutation,
  useGetShopInvoiceQuery,
  useAddShopInvoicePaymentMutation,
  useDeleteShopInvoicePaymentMutation,
  useGetProductSuppliersQuery,
  useLazyGetProductSuppliersQuery,
  useLazyGetSupplierProductsQuery,
  useLinkProductToSupplierMutation,
  useLazyGetProductHistoryQuery,
  useGetProductBarcodesQuery,
  useAddProductBarcodeMutation,
  useSetBarcodePrimaryMutation,
  useDeleteBarcodeMutation,
  useLazyScanBarcodeQuery,
  useGetWarehouseAlertsQuery,
  useReceiveStockMutation,
  useGetWarehouseForecastDataMutation,
  useGetUnitsQuery,
  useCreateUnitMutation,
  useGetTaxGroupsQuery,
  // ─── Digital Signage ────────────────────────────────────────────
  useGetDevicesQuery,
  useGetDeviceQuery,
  useCreateDeviceMutation,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,
  useAssignDevicePlaylistMutation,
  useGetPlaylistsQuery,
  useGetPlaylistQuery,
  useCreatePlaylistMutation,
  useUpdatePlaylistMutation,
  useDeletePlaylistMutation,
  useAddPlaylistItemMutation,
  useRemovePlaylistItemMutation,
  useReorderPlaylistItemsMutation,
  useGetMediaQuery,
  useDeleteMediaMutation,
  useGetDashboardSummaryQuery,
  // ─── Playlist Groups ──────────────────────────────────────────────
  useGetPlaylistGroupsQuery,
  useGetPlaylistGroupQuery,
  useCreatePlaylistGroupMutation,
  useUpdatePlaylistGroupMutation,
  useDeletePlaylistGroupMutation,
  useAddPlaylistToGroupMutation,
  useUpdatePlaylistGroupItemMutation,
  useRemovePlaylistFromGroupMutation,
  useReorderPlaylistGroupItemsMutation,
  useAssignDevicePlaylistGroupMutation,
} = attoDeskApi;
